<script lang="ts">
  import Content from "../../components/Content.svelte";
  import Page from "../../components/Page.svelte";
  import { ethereum } from "../../store/ethereum";
  import ClaimCard from "./section/ClaimCard.svelte";
  import InfoCard from "./section/InfoCard.svelte";

  $: unsupportedNetwork =
    $ethereum.chainId !== 1 && $ethereum.chainId !== 42161;
    
</script>

<Page>
  <div class="staking_outer">
    <div class="container">
      <div class="title-controls">
        <h1>Pre-Sale</h1>      
      </div>
  
      <div class="common_card_heading">
        <a href="/"> <i class="fas fa-arrow-left" /> Return home</a>
      </div>
        
        <div class="presale">
          {#if unsupportedNetwork}
            <div class="network-info">
              <h3>
                <i class="fas fa-exclamation-circle" />
                Unsupported network.
              </h3>
              Only Ethereum and Arbitrum networks are supported.
              <br> Please disconnect and re-connect your wallet with the 
              appropriate network.
            </div>
          {:else}
            <!-- <PresaleCard /> -->
            <ClaimCard />
          {/if}
        </div>
    </div>
  </div>
    
</Page>

<style>
  .staking_outer{
    background: #181826;
    padding:50px 0;
  }
  .black-box {
    flex-basis: 50%;
    margin-bottom: 20px;
  }

  .disclaimer {
    background: black;
    color: #fff;
    font-size: 0.8rem;
    max-width: 600px;
    border-radius: 10px;
    margin: 50px auto;
    padding: 20px;
  }

  .staking {
    max-width: 100%;
    width: 100%;
    margin: 40px auto;   
  }

  .coming-soon {
    cursor: default;
    max-width: 100%;
    padding: 20px;
    border-radius: 30px;
    background-color: var(--button-color);
    color: var(--button-text-color);
    width: 400px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .coming-soon h1 {
    margin: 0px;
  }

  .coming-soon-text {
    opacity: 0.5;
  }

  .error-alert {
    background-color: #fff;
    color: rgb(158, 25, 65);
    padding: 20px;
    border-radius: 15px;
  }

  .error-alert h3 {
    margin-top: 0rem;
    margin-bottom: 1rem;
  }

  .network-info {
    padding: 20px;
    border-radius: 20px;
    background-color: #232539;
    color: #fff;
    margin-bottom: 30px;
  }
  .tocken_number{
    word-break: break-word;
  }
  .network-info p {
    margin-bottom: 0;
  }

  .network-info .btn-link {
    color: white;
    opacity: 0.7;
    font-size: 0.9rem;
  }

  .tvl {
    padding: 20px 0px;
    padding-bottom: 40px;
  }

  .tvl h1 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .tvl p {
    margin-bottom: 0px;
    margin-top: 0px;
    opacity: 0.5;
  }

  a {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    .black-box {
      padding: 0px;
      transform: scale(1);
      margin-bottom: 20px;
    }

    .presale {
      width: 100%;
      padding: 10px;
      margin: 20px auto;
      /* transform: scale(1.1); */
    }

    .black-box h1 {
      font-size: 2rem;
    }

    h1 br {
      display: none;
    }

    .presale-info {
      padding: 20px;
    }

    .info {
      font-size: 0.7rem;
    }
  }
  .common_card_heading{
  padding: 15px 20px;
  background: #232539;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.common_card_heading a{
  margin-bottom: 0;
  color:#fff;
  text-decoration: none;
}


.blue_card_common{
  display: flex;
  align-items: center;
  padding: 30px;  
  background: #232539;
  margin-top: 7px;
}

.blue_card_common h3{
  font-size: 18px;
  margin-bottom: 15px;
}
.blue_card_common p{
  color:#a1a1a1;
  font-style: italic;  
  margin-bottom: 0;
  line-height: 21px;
}
.blue_card_common .coinicon{
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.blue_card_common .coinicon img{
    height:111px;
}
@media (max-width:768px){
  .blue_card_common{
    flex-direction: column;
    padding: 15px;
  }
  .text_left{
    order:2;
    margin-top:15px;
  }
}
</style>
